import * as React from 'react';
export var Check = function () {
    return React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-hidden": "true" },
        React.createElement("path", { d: "M11.35 18.947c-.404.108-.849.054-1.236-.187l-5.326-3.32c-.768-.48-1.017-1.514-.557-2.312.461-.798 1.457-1.057 2.225-.578l3.987 2.485 5.56-9.243c.475-.789 1.475-1.029 2.235-.536s.99 1.533.515 2.322l-6.388 10.62a1.62 1.62 0 0 1-1.014.75", fill: "currentColor" }));
};
